//* 组件库
import { $loading } from "various-ui";
//* 组件属性
import type { HistoryData } from "../index";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();
    //* 响应式变量
    const refs = {
        data: ref<HistoryData[]>([]),
        count: ref<number>(0),
        page: ref<number>(1),
    };

    const methods = {
        //* 获取数据
        acquire: (page?: number) => {
            api.frontend("/api/user/history", {
                headers: { "X-Token": useCookie("X-Token").value || "" },
                method: "POST",
                data: { page: page || refs.page.value },
                success: (response) => {
                    refs.page.value = page || refs.page.value;
                    refs.data.value = response.data;
                    refs.count.value = response.count;
                },
            });
        },

        //* 删除记录
        delete: (data: HistoryData) => {
            //* 调用接口修改数据
            $loading.open({ message: i18n.t("UnderLoad") });
            api.frontend("/api/user/history", {
                data: { id: data.id },
                method: "DELETE",
                headers: { "X-Token": useCookie("X-Token").value || "" },
                finally: () => $loading.close(),
                success: () => {
                    //* 如果删除的是最后一个收藏夹 or 收藏，则页码减一
                    if (refs.data.value.length <= 1) refs.page.value = Math.max(refs.page.value - 1, 1);

                    //* 数据更新
                    methods.acquire();
                },
            });
        },
    };

    return { refs, methods };
};
